import React, { ReactNode } from "react";
import "./TextButton.css";

interface Props {
  onClick: () => void;
  text: string | ReactNode;
  disabled?: boolean;
  big?: boolean;
  ref?: React.Ref<HTMLButtonElement>;
}

function TextButton(props: Props) {
  const handleClick = () => {
    props.onClick();
  };

  const classes = `text-button-wrapper ${props.big ? "big-text" : ""}`;

  return (
    <span className={classes}>
      <button
        ref={props.ref}
        type="button"
        // title={props.text}
        onClick={handleClick}
        disabled={props.disabled}
        aria-disabled={props.disabled}
      >
        {props.text}
      </button>
    </span>
  );
}

export default TextButton;
